import React from 'react';
import { Route, Switch, RouteComponentProps, Redirect } from 'react-router-dom';
import Home from "./layout/Home";
import MenuHome from './src/index';
import ErrorComp from '../components/Empty';
import './index.less';

interface IProps {}
interface IState {}

class College extends React.Component<IProps & RouteComponentProps, IState> {
  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.state = {}
  }
  render() {
    return (
      <div className="college">
        <div className="college_cont">
          <Switch>
            <Route exact path='/' component={Home} />
            <Route path='/college/menu' component={MenuHome} />
            <Route path='/college' component={Home} />
            <Redirect from="/" to="/college/home" />
            <Route component={ErrorComp} />
          </Switch>
        </div>
      </div>
    )
  }
}

export default College;